import React, { useState, useEffect } from "react";
import api from "../../utils/ApiMethod";
import Breadcrumb from "../../components/common/Breadcrumb";

import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Box,
  Text,
} from "@chakra-ui/react";
import { Helmet } from "react-helmet";

const UpcomingEvents2 = () => {
  const [dso, setDso] = useState([]);

  const handleFetchData = async () => {
    try {
      // fetch from /data/events-log.json
      const data = await api.fetchData("/events-log");
      //   filter those whose eventDate exceeds today
      setDso(
        data
          .filter((item) => new Date(item.eventDate) >= new Date())
          .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate))
          .reverse(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    handleFetchData();
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Upcoming Sporting Events | Sports Department Bihar | BSSA</title>
        <meta
          name="description"
          content="बिहार राज्य खेल प्राधिकरण के आगामी कार्यक्रम: इस पेज पर विभिन्न आगामी खेल आयोजनों और प्रतियोगिताओं की जानकारी उपलब्ध है। यहां राज्य भर में होने वाले खेल कार्यक्रमों के बारे में अद्यतन जानकारी प्राप्त की जा सकती है।"
        />
      </Helmet>

      <Breadcrumb
        pageName="D.S.O-Directory"
        pageTitle="D.S.O-Directory"
        id="#dso-directory"
        img_url="/img/annual khel 01.jpg"
        mobile_banner="/img/annual khel mobile view 576 x600 01.jpg"
      />

      <h1 className="pb-5" style={{ marginTop: "30px", marginBottom: "30px" }}>
        आगामी कार्यक्रम
      </h1>
      {!dso.length ? (
        <Box
          boxShadow={"lg"}
          marginRight={"4%"}
          marginLeft={"4%"}
          marginBottom={"30px"}
          padding={"60px 20px"}
          textAlign={"center"}
        >
          <Text fontSize={"1.5rem"} fontWeight={"medium"} color={"gray.600"}>
            आगामी कार्यक्रमों एवं आयोजन की समय-सारिणी शीघ्र ही प्रकाशित की
            जाएगी।
          </Text>
        </Box>
      ) : (
        <Box>
          <TableContainer
            boxShadow={"lg"}
            alignContent={"center"}
            justifyContent={"center"}
            marginRight={"4%"}
            marginLeft={"4%"}
            paddingTop={"5px"}
            paddingBottom={"30px"}
          >
            <Table variant="striped" colorScheme="teal">
              <Thead>
                <Tr>
                  <Th fontSize={"1.5rem"}>क्र.सं.</Th>
                  <Th fontSize={"1.5rem"}>कार्यक्रम/ प्रतियोगिता</Th>
                  <Th fontSize={"1.5rem"}>आगामी तिथि </Th>
                </Tr>
              </Thead>

              <Tbody>
                {dso?.map((item, i) => (
                  <Tr key={i}>
                    <Td>{i + 1}</Td>
                    <Td>{item?.eventName}</Td>
                    <Td>{item?.eventDateString} </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </>
  );
};
export default UpcomingEvents2;
